export default __webpack_public_path__ + "static/media/magicsnacks@2x.ef759048.jpg";